import {
  CheckCircle
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PaymentsApiService from "../../../../infrastructure/api/payments";


const PaymentSelection= ({
  requestId: propRequestId,
  isModal = false,
  onSelectPayment: onSelectPaymentCallback,
  onClose,
}) => {
  const params = useParams();
  const requestId = propRequestId || params.requestId;
  const navigate = useNavigate();

  const baseUrl = window.globalConfig?.API_URL || "";
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [expandedPayment, setExpandedPayment] = useState(null);

  useEffect(() => {
    console.log("useEffect triggered with requestId:", requestId);
    if (requestId) {
      loadPayments();
    } else {
      console.error("requestId is null or undefined!");
      setLoading(false);
    }
  }, [requestId]);

  const loadPayments = async () => {
    try {
      setLoading(true);
      const response = await PaymentsApiService.getPaymentMethodList(
        requestId
      );

      if (response.isSuccess) {
        setData(response.data);
      } else {
        toast.error(response.message || "خطا در دریافت اطلاعات");
        setData(null);
      }
    } catch (error) {
      console.error("خطا در دریافت پرداخت‌ها:", error);
      toast.error("خطا در دریافت اطلاعات پرداخت‌ها");
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPayment = (pkg) => {
    setSelectedPayment(pkg);
    setConfirmDialogOpen(true);
  };

  const handleConfirmSelection = async () => {
    try {
      // اگر modal است و callback داریم، اطلاعات را به والد برمی‌گردانیم
      if (isModal && onSelectPaymentCallback) {
        onSelectPaymentCallback(selectedPayment);
        console.log('looooooooog :' , selectedPayment);
        
        setConfirmDialogOpen(false);
        if (onClose) {
          onClose();
        }
        return;
      }

      // اگر صفحه مستقل است، API برای ثبت انتخاب پیمانکار فراخوانی می‌شود
      // TODO: باید endpoint مناسب اضافه شود
      toast.success(
        `پرداخت "${selectedPayment.title}" با موفقیت انتخاب شد`
      );
      setConfirmDialogOpen(false);
      // navigate به صفحه Information
      navigate(`/SLN/Customer/Requests/Information?id=${requestId}`);
    } catch (error) {
      console.error("خطا در ثبت انتخاب:", error);
      toast.error("خطا در ثبت انتخاب روش پرداخت");
    }
  };

  const toggleExpand = (PaymentKind) => {
    setExpandedPayment(expandedPayment === PaymentKind ? null : PaymentKind);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!data ||   data.length === 0) {
    return (
      <Container maxWidth="lg" sx={{ mt: isModal ? 2 : 4 }}>
        <Alert severity="info">
          هیچ پرداختی برای این درخواست یافت نشد. لطفاً بعداً دوباره تلاش کنید.
        </Alert>
        {!isModal && (
          <Box mt={2}>
            <Button variant="contained" onClick={() => navigate(-1)}>
              بازگشت
            </Button>
          </Box>
        )}
      </Container>
    );
  }

  return (
    <Container
      maxWidth="xl"
      sx={{ mt: isModal ? 2 : 4, mb: isModal ? 2 : 4, px: isModal ? 2 : 3 }}
    >
       

      {/* Payments Grid */}
      <Grid container spacing={3}>
        {data.map((pkg) => (
          <Grid item xs={12} key={pkg.id}>
            <Card
              elevation={3}
              sx={{
                borderRight: 4,
                borderColor: "primary.main",
                transition: "all 0.3s",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  {/* عنوان و اطلاعات اصلی */}
                  <Grid item xs={12} md={4}>
                    <Typography variant="h6" gutterBottom>
                      {pkg.PaymentTitle}
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                      <Chip
                        label={`${pkg.title}  `}
                        color="primary"
                        size="small"
                      />
                      {pkg.status === 1 && (
                        <Chip
                          icon={<CheckCircle />}
                          label="تایید شده"
                          color="success"
                          size="small"
                        />
                      )}
                    </Box>
 
                  </Grid>
 

                  {/* شرایط و اقدامات */}
                  <Grid item xs={12} md={4}>
                     

                    <Box mt={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        onClick={() => handleSelectPayment(pkg)}
                        sx={{ mb: 1 }}
                      >
                        انتخاب این پرداخت
                      </Button> 
                                        <Grid container spacing={2}>                                          
                                            <Grid item xs={12}>
                                              <Typography variant="subtitle2" gutterBottom>
                                                توضیحات:
                                              </Typography>
                                              <Typography variant="body2" color="text.secondary">
                                                {pkg.description}
                                              </Typography>
                                            </Grid>                                         
                                          </Grid>
                    </Box>
                  </Grid>
                </Grid>
 
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Confirm Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>تایید نهایی </DialogTitle>
        <DialogContent>
           
             <Box>
 
 





              <Alert severity="info" sx={{ mt: 2 }}>
 بعد از طی نمودن مراحل پرداخت لطفا رسید پرداخت و شماره پیگیری را وارد نمایید

              </Alert>
            </Box>
        
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)}>انصراف</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmSelection}
          >
            تایید و ادامه
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default PaymentSelection;
